// extracted by mini-css-extract-plugin
export default {"root":"MerchantAccountSelector_root__H+tPz","select":"MerchantAccountSelector_select__QL+RZ"};